import { useState, useEffect } from "react";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { StripeConnectInstance } from "@stripe/connect-js";
import { NetworkCalls } from "../NetworkCalls";

export const useStripeConnect = (connectedAccountId: string | undefined) => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState<StripeConnectInstance | undefined>();

  useEffect(() => {
    if (connectedAccountId) {
      const fetchClientSecret = async () => {
        try {
          const response = await NetworkCalls.createStripeAccountSession(connectedAccountId);
          return response.client_secret;
        } catch (error) {
          console.error("Error fetching client secret:", error);
          throw new Error("An error occurred while fetching client secret");
        }
      };

      const initializeStripeConnect = async () => {
        try {
          const publishableKey = await NetworkCalls.getStripePublishableKey();
          setStripeConnectInstance(
            loadConnectAndInitialize({
              publishableKey,
              fetchClientSecret,
              appearance: {
                overlays: "dialog",
                variables: {
                  colorPrimary: "#36469C",
                },
              },
            })
          );
        } catch (error) {
          console.error("Error loading Stripe key:", error);
        }
      };

      initializeStripeConnect();
    }
  }, [connectedAccountId]);

  return stripeConnectInstance;
};

export default useStripeConnect;
